<script>
import {link , push} from 'svelte-spa-router'
import { _ } from "svelte-i18n";
import UserStore from '../stores/user';

export let activeLink;

export let back_link = '/';
export let hide_back = false;


const parts = window.location.hash.replace("#/", "").split("/");


let logout_active = false;
if (typeof appSys === 'undefined' || appSys==false) {
  logout_active = true;
}



let isMenuOpen = false;

function toggleMenu() {
  isMenuOpen = !isMenuOpen;
}

const logOut = ()=> {

  UserStore.update(user=>{    
    return {};
  })

  push('/login');

}
</script>
  
<style>
  .header {
    background-color: #050A30;
    width: 200px;
    box-sizing: border-box;
    border-left: 1px solid #e4e4e4;

    background-color: #fff;
    border: 0;
    box-shadow: 0px 0px 13px #e1e1e1;
    box-shadow: rgba(17, 43, 85, 0.1) 0px 12px 28px 0px;
    z-index: 1;
  }
  .logo {
    box-sizing: border-box;
    padding: 20px 40px 15px;
  }
  .logo img {
    width: 100%;
  }
  ul {
    list-style: none;
    margin: 0;
    padding:20px;
  }
  a,.logout {
    /* color: #fff;; */
    text-decoration: none;
    display: block;
    padding:5px 0;
    font-size: 14px;;
    cursor: pointer;
  }
  .profile {
    color:#fff;
    padding:10px 20px;
    background-color: var(--theme-one-color);
    background: linear-gradient(90deg, var(--theme-one-color), var(--theme-one-color-gradient));
    font-size: 14px;;

    /* color: var(--theme-one-color);
    background-color: #fff; */

    color: #fff;
    padding: 10px 20px;
    background-color: var(--theme-one-color);
    background: linear-gradient(90deg, var(--theme-one-color), var(--theme-one-color-gradient));
    font-size: 14px;
    margin: 0 10px;
    border-radius: 70px;
    text-align: center;
  }
  .nav-links a {
    display: flex;
    align-items: center;
  }
  .nav-links img {
    position:relative;
    margin-left: 10px;;
    height: 20px;;   
    top:2px; 
  }
  .logout i {
    color: var(--theme-one-color);
    margin-left: 12px;;
  }
  .hamburger {
    display: none;
  }

  .overlay {
    display: none;;
  }

  @media screen and (max-width:600px) {

    .hamburger {
      width:40px;
      height: 40px;;
      position: absolute;
      top:0;  
      right:0;  
      display: flex;
      align-items: center;
      justify-content: center;
      gap:5px;
      flex-direction: column;
      background-color: transparent;
      border:0;
    }
    .hamburger span {
      width:90%;
      height: 4px;
      background-color: var(--theme-one-color);
      border-radius: 4px;
    }

    .header {
      right: -200px;
      position: absolute;
      top:0;
      height: 100%;
      transition: 200ms all;
    }
    .header.active {
      right:0;
    }
    .overlay {
      width:100%;
      background-color: #00000083;
      height: 100%;
      display: none;
      position: absolute;
      top:0;
      right:0;
      opacity: 0;
      transition: 200ms all;
    }
    .overlay.active  {
      display: block;
      opacity: 1;
    }

  }
</style>

<button class="hamburger" on:click={toggleMenu}>
  <span></span>
  <span></span>
  <span></span>
</button>
<div class="overlay" id="overlay" on:click={toggleMenu} class:active={isMenuOpen}></div>
<div class="header"  class:active={isMenuOpen}>
  <!-- <div class="logo">
    <a href="/home" use:link><img src="images/logo.svg" class="logo"></a>    
  </div> -->

  
  <nav class="mobile-nav">
    <div class="logo">
      {#if $UserStore.id==1539}
        <img src="{siteUrl}images/5.svg">
      {:else}
        {#if shippingo=="1"}
        <img src="{siteUrl}images/0.svg">
        {:else if shippingo=="2"}
        <img src="{siteUrl}images/datalogics.svg">
        {:else if shippingo=="10"}
        Ai Visual merchandiser
        <!-- <img src="{siteUrl}images/merchandiser.svg"> -->
        {:else}
        <img src="{siteUrl}images/{shipping_push_supplier}.svg">
        {/if}
      {/if}
    </div>
    {#if $UserStore.firstname}
    <div class="profile">      
      <!-- <div>ברוך הבא</div> -->      
      <div>{$UserStore.firstname} {#if $UserStore.lastname}{$UserStore.lastname}{/if}</div>
      <div>{$UserStore.company}</div>
    </div>
    {/if}    
    <div class="nav-links" id="nav-links" class:active={isMenuOpen}>
      {#if $UserStore.manager==1}
      <ul>
        <li><a href="/customer_dashboard" use:link on:click={toggleMenu}><span class="text-[var(--theme-one-color)] px-2"><i class="fa-solid fa-users"></i></span><span>{$_('header.customers')}</span></a></li>
        <li><a href="/my_customers/{$UserStore.id}" use:link on:click={toggleMenu}><span class="text-[var(--theme-one-color)] px-2"><i class="fa-solid fa-users"></i></span><span>{$_('header.my_customers')}</span></a></li>
        <li><a href="/create_customer" use:link on:click={toggleMenu}><span class="text-[var(--theme-one-color)] px-2"><i class="fa-solid fa-user-plus"></i></span><span>{$_('header.create_customers')}</span></a></li>
      </ul>
      {:else}
        {#if shippingo!="10" && shippingo!="20"}
        <ul>
          <!-- <li><a class:active-link="{activeLink === 'customers'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/gettin.svg"></span><span>{$_('header.getting_started')}</span></a></li>
          <li><a class:active-link="{activeLink === 'customers'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/dash.svg"></span><span>{$_('header.dashboard')}</span></a></li>
          <li><a class:active-link="{activeLink === 'customers'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/customers.svg"></span><span>{$_('header.customers')}</span></a></li> -->
          <li><a class:active-link="{activeLink === 'shipments'}" href="/dashboard?tab=2" use:link on:click={toggleMenu}><span class="text-[var(--theme-one-color)] px-2"><i class="fa-solid fa-boxes-stacked"></i></span><span>{$_('header.shipments')}</span></a></li>
          <li><a class:active-link="{activeLink === 'reports'}" href="/reports" use:link on:click={toggleMenu}><span class="text-[var(--theme-one-color)] px-2"><i class="fa-solid fa-chart-column"></i></span><span>{$_('header.reports')}</span></a></li>
          {#if ($UserStore?.erp==1)}
          <li><a class:active-link="{activeLink === 'shipments'}" href="/bins" use:link on:click={toggleMenu}><span class="text-[var(--theme-one-color)] px-2"><i class="fa-solid fa-layer-group"></i></span><span>{$_('header.bins')}</span></a></li>
          {/if}
          <li><a class:active-link="{activeLink === 'shipments'}" href="/locations" use:link on:click={toggleMenu}><span class="text-[var(--theme-one-color)] px-2"><i class="fa-solid fa-warehouse"></i></span><span>{$_('header.locations')}</span></a></li>
          <li><a class:active-link="{activeLink === 'shipments'}" href="/companies" use:link on:click={toggleMenu}><span class="text-[var(--theme-one-color)] px-2"><i class="fa-solid fa-truck-ramp-box"></i></span><span>
            {#if shippingo=="1" || shippingo=="2"}
            {$_('header.companies')}
            {:else}
            {$_('header.account')}
            {/if}
          </span></a></li>
          <li><a class:active-link="{activeLink === 'shipments'}" href="/settings" use:link on:click={toggleMenu}><span class="text-[var(--theme-one-color)] px-2"><i class="fa-solid fa-sliders"></i></span><span>{$_('header.shipping_preferences')}</span></a></li>
          <li><a class:active-link="{activeLink === 'shipments'}" href="/support" use:link on:click={toggleMenu}><span class="text-[var(--theme-one-color)] px-2"><i class="fa-solid fa-life-ring"></i></span><span>{$_('header.support')}</span></a></li>
          {#if shippingo!="2" && shippingo!="1" && shipping_push_supplier==62}
          <li>
            <a class:active-link="{activeLink === 'shipments'}" href="/docs" use:link on:click={toggleMenu}><span class="text-[var(--theme-one-color)] px-2"><i class="fa-brands fa-connectdevelop"></i></span><span>{$_('header.docs')}</span></a>
            {#if parts.indexOf("docs")!==-1}
            <ul class="!mt-0 !pt-0">
              <li><a href="/docs/wordpress" use:link on:click={toggleMenu}><span class="text-[var(--theme-one-color)] px-2"><img src="{siteUrl}images/docs/wordpress.svg"></span><span>{$_('header.wordpress')}</span></a></li>
              <li><a href="/docs/shopify" use:link on:click={toggleMenu}><span class="text-[var(--theme-one-color)] px-2"><img src="{siteUrl}images/docs/shopify.svg"></span><span>{$_('header.shopify')}</span></a></li>
              <li><a href="/docs/wix" use:link on:click={toggleMenu}><span class="text-[var(--theme-one-color)] px-2"><img src="{siteUrl}images/docs/wix.svg"></span><span>{$_('header.wix')}</span></a></li>
              <li><a href="/docs/konimbo" use:link on:click={toggleMenu}><span class="text-[var(--theme-one-color)] px-2"><img src="{siteUrl}images/docs/konimbo.jpg"></span><span>{$_('header.konimbo')}</span></a></li>
              <li><a href="/docs/rest" use:link on:click={toggleMenu}><span class="text-[var(--theme-one-color)] px-2"><img src="{siteUrl}images/docs/api.svg"></span><span>{$_('header.rest')}</span></a></li>
            </ul>          
            {/if}
          </li>
          {/if}
        </ul>
        {/if}
      {/if}


      {#if ($UserStore?.erp==1)}
      <ul>
        <li><a href="/integrations" use:link on:click={toggleMenu}><span class="text-[var(--theme-one-color)] px-2"><i class="fa-solid fa-link"></i></span><span>{$_('integration.integration')}</span></a></li>
        <li><a href="/products" use:link on:click={toggleMenu}><span class="text-[var(--theme-one-color)] px-2"><i class="fa-solid fa-box"></i></span><span>{$_('integration.products')}</span></a></li>
      </ul>          
      {/if}

      {#if ($UserStore?.settings?.shipping_settings?.tpl==1)}
      <ul>
        <li><a href="/purchase-orders" use:link on:click={toggleMenu}><span class="text-[var(--theme-one-color)] px-2"><i class="fa-solid fa-file-circle-plus"></i></span><span>הזמנות רכש</span></a></li>
        <li><a href="/purchase-orders/history" use:link on:click={toggleMenu}><span class="text-[var(--theme-one-color)] px-2"><i class="fa-solid fa-table-list"></i></span><span>היסטוריית רכש</span></a></li>
        <li><a href="/purchase-orders/items" use:link on:click={toggleMenu}><span class="text-[var(--theme-one-color)] px-2"><i class="fa-solid fa-boxes-stacked"></i></span><span>פריטי רכש</span></a></li>
        <li><a href="/purchase-orders/locations" use:link on:click={toggleMenu}><span class="text-[var(--theme-one-color)] px-2"><i class="fa-solid fa-location-dot"></i></span><span>מיקומי יציאה</span></a></li>

      </ul>          
      {/if}


      {#if shippingo=="20"}
      <ul>
        <li><a href="/bot/bots" use:link on:click={toggleMenu}>
          <span class="text-[var(--theme-one-color)] px-2"><i class="fa-brands fa-connectdevelop"></i></span>
          <span>{$_('bot.header.bots')}</span></a>
        </li>
        <li><a href="/bot/bases" use:link on:click={toggleMenu}>
          <span class="text-[var(--theme-one-color)] px-2"><i class="fa-brands fa-connectdevelop"></i></span>
          <span>{$_('bot.header.data_sources')}</span></a>
        </li>
        <li>
          <a href="/bot/coversations" use:link on:click={toggleMenu}>
            <span class="text-[var(--theme-one-color)] px-2"><i class="fa-solid fa-comments"></i></span>
            <span>{$_('bot.header.conversations')}</span>
          </a>
        </li>
        <li><a href="/bot/users" use:link on:click={toggleMenu}>
          <span class="text-[var(--theme-one-color)] px-2"><i class="fa-solid fa-users"></i></span>
          <span>{$_('bot.header.users')}</span></a>
        </li>
        <li>
          <a href="/bot/settings" use:link on:click={toggleMenu}>
            <span class="text-[var(--theme-one-color)] px-2"><i class="fa-solid fa-gear"></i></span>
            <span>{$_('bot.header.settings')}</span>
          </a>
        </li>
      </ul>
      {/if}


      {#if shippingo=="10" || $UserStore?.id==2971 || $UserStore?.id==1294}
      <ul>
        <li><a href="/merchandiser/categories" use:link on:click={toggleMenu}>
          <span class="text-[var(--theme-one-color)] px-2"><i class="fa-solid fa-up-down-left-right"></i></span>
          <span>{$_('header.merchandiser_categories')}</span></a>
        </li>
        <li>
          <a href="/merchandiser/support" use:link on:click={toggleMenu}>
            <span class="text-[var(--theme-one-color)] px-2"><i class="fa-solid fa-life-ring"></i></span>
            <span>{$_('header.support')}</span>
          </a>
        </li>
        <li>
          <a href="/merchandiser/docs" use:link on:click={toggleMenu}>
            <span class="text-[var(--theme-one-color)] px-2"><i class="fa-brands fa-connectdevelop"></i></span>
            <span>{$_('header.docs')}</span>
          </a>
        </li>
      </ul>
      {/if}


      {#if shippingo!="2" && shippingo!="1" && $UserStore.manager!="1" && $UserStore.manager!=1 && $UserStore.id!=1539}
      <ul>
        <li><a class:active-link="{activeLink === 'shipments'}" href="/services" use:link on:click={toggleMenu}><span class="text-[var(--theme-one-color)] px-2"><i class="fa-brands fa-product-hunt"></i></span><span>{$_('header.services')}</span></a></li>
      </ul>
      {/if}
      <!-- <ul>
        <li><a class:active-link="{activeLink === 'customers'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/gettin.svg"></span><span>{$_('header.getting_started')}</span></a></li>
        <li><a class:active-link="{activeLink === 'customers'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/dash.svg"></span><span>{$_('header.dashboard')}</span></a></li>
        <li><a class:active-link="{activeLink === 'customers'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/customers.svg"></span><span>{$_('header.customers')}</span></a></li>
        <li><a class:active-link="{activeLink === 'shipments'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/shipments.svg"></span><span>{$_('header.shipments')}</span></a></li>
        <li><a class:active-link="{activeLink === 'shipments'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/rewards.svg"></span><span>{$_('header.rewards')}</span></a></li>
      </ul>
      <ul>
        <li><a class:active-link="{activeLink === 'customers'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/returns.svg"></span><span>{$_('header.returns_replace')}</span></a></li>
        <li><a class:active-link="{activeLink === 'customers'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/history.svg"></span><span>{$_('header.shipping_history')}</span></a></li>
        <li><a class:active-link="{activeLink === 'shipments'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/settings.svg"></span><span>{$_('header.shipping_preferences')}</span></a></li>
      </ul>
      <ul>
        <li><a class:active-link="{activeLink === 'shipments'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/complaints.svg"></span><span>{$_('header.complaints')}</span></a></li>
        <li><a class:active-link="{activeLink === 'shipments'}" href="/dashboard" use:link on:click={toggleMenu}><span><img src="images/chat.svg"></span><span>{$_('header.live_chat')}</span></a></li>
      </ul>
      -->
      {#if logout_active}
      <ul>        
        <li><span class="logout" on:click={logOut}><span><i class="fa-solid fa-arrow-right-from-bracket"></i></span><span>{$_('header.logout')}</span></span></li>
      </ul>
      {/if}

    </div>
  </nav>
</div>